import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from 'contexts/ThemeContext';

import { Text } from 'components/DataDisplay';
import { Item } from 'components/Layout';

export const PendingChangeDiff = ({ diff, format }) => {
  const { themeColors } = useTheme();
  const { designSystem } = themeColors;
  const render = value => (format ? format(value) : value);
  const previousValue = diff.old == null ? null : render(diff.old);

  return (
    <Item
      flex
      style={{
        alignItems: 'baseline',
        gap: '6px',
        flexWrap: 'wrap',
        minWidth: 0
      }}
    >
      <Text
        component="span"
        fontSize="12px"
        style={{
          color: designSystem.muted,
          textDecoration: previousValue ? 'line-through' : 'none',
          wordBreak: 'break-word'
        }}
      >
        {previousValue || '—'}
      </Text>
      <Text
        component="span"
        fontSize="12px"
        style={{ color: designSystem.faint }}
      >
        →
      </Text>
      <Text
        component="span"
        fontSize="12px"
        fontWeight={700}
        style={{ color: designSystem.ink, wordBreak: 'break-word' }}
      >
        {render(diff.new)}
      </Text>
    </Item>
  );
};

PendingChangeDiff.defaultProps = {
  format: null
};

PendingChangeDiff.propTypes = {
  diff: PropTypes.shape().isRequired,
  format: PropTypes.func
};

export default PendingChangeDiff;
